export const LocationFromJSON = (json: ILocation): ILocationModel => {
	const fromJSON = (json: ILocation) => {
		const {
			crm_id,
			google_url,
			count_ratings,
			is_pickup_location,
			place_id,
			bookings_count,
			is_meet_and_greet,
			name_en,
			is_active,
			address_street,
			address_house_number,
			...rest
		} = json

		return {
			...rest,
			crmID: crm_id,
			googleUrl: google_url,
			countRatings: count_ratings,
			bookingsCount: bookings_count,
			placeID: place_id,
			isPickupLocation: is_pickup_location,
			isMeetAndGreet: is_meet_and_greet,
			nameEn: name_en,
			isActive: is_active,
			addressStreet: address_street,
			addressHouseNumber: address_house_number,
		}
	}

	return { ...fromJSON(json) }
}

export const locationToJSON = (obj: Partial<ILocationModel>): Partial<ILocation> => {
	const {
		crmID,
		googleUrl,
		countRatings,
		placeID,
		isPickupLocation,
		isMeetAndGreet,
		nameEn,
		isActive,
		addressStreet,
		addressHouseNumber,
		...rest
	} = obj

	return {
		...rest,
		crm_id: crmID,
		google_url: googleUrl,
		count_ratings: countRatings,
		place_id: placeID,
		is_pickup_location: isPickupLocation,
		is_meet_and_greet: isMeetAndGreet,
		name_en: nameEn,
		is_active: isActive,
		address_street: addressStreet,
		address_house_number: addressHouseNumber,
	}
}

export const LocationCityFromJSON = (json: ILocationCity): ILocationCityModel => {
	const fromJSON = (json: ILocationCity) => {
		const { is_visible, ...rest } = json

		return {
			...rest,
			isVisible: is_visible,
		}
	}

	return { ...fromJSON(json) }
}

export const locationCityToJSON = (obj: Partial<ILocationCityModel>): Partial<ILocationCity> => {
	const { isVisible, ...rest } = obj

	return {
		...rest,
		is_visible: isVisible,
	}
}
